import { IEmployeeDetailsRequestType, IPendingEmployeeRequestType, IRequestType } from "./type"

const employeeBaseUrl = '/employee'
export const EmployeeContractEndpointConst = {
    employeeContractList: `${employeeBaseUrl}/contracts/list`,
    employeeInfo: `${employeeBaseUrl}/contract/remaining`,
    addContractInfo: `${employeeBaseUrl}/contract`,
    checkRunningContract: `${employeeBaseUrl}/contract/running`,
}

export const getCurrentContractDetailByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/${params.contractId}/contract/information`
}

export const getEmployeeDetailsByEmployeeCodeUrl = (params: IEmployeeDetailsRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/contract/employee-information`
}

export const getContractHistoryUrl = (params: IEmployeeDetailsRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/contract/history`
}
export const getInActiveContractHistoryUrl = (params: IEmployeeDetailsRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/contract/history?recordStatus=InActive`
}
export const deleteContractByIdUrl = (params: IRequestType) => {
    return `${employeeBaseUrl}/contract/${params.contractId}`
}
export const getIncentivesDetailByCodeUrl = (params: IEmployeeDetailsRequestType) => {
    return `${employeeBaseUrl}/${params.employeeCode}/incentives`
}
export const getPendingEmployeeLeaveUrl = (params: IPendingEmployeeRequestType) => {
    return `${employeeBaseUrl}/leave/application/${params.employeeCode}/${params.status}/count`
}
export const getPendingEmployeeOverTimeUrl = (params: IPendingEmployeeRequestType) => {
    return `${employeeBaseUrl}/overtime/${params.employeeCode}/${params.status}/count`
}
export const getPendingEmployeeSalaryUrl = (params: IPendingEmployeeRequestType) => {
    return `${employeeBaseUrl}/salary/${params.employeeCode}/${params.status}/count`
}